import styled from 'styled-components';
import { MAX_WRAPPER_SIZE, FRAME_MOBILE_SIZE } from '../../../../settings';


export default {
    BPFrame: styled.div.attrs({ className: 'billing-page-frame' })`
        width: 100%;
        height: auto;
    `,
    MainContainer: styled.div.attrs({ className: 'main-container' })`
        width: 100%;
        overflow: hidden;
        position: relative;
        @media (min-height: 1500px) {
            min-height: 100vh;
        }
    `,
    MainBox: styled.div.attrs({ className: 'main-box' })`
        max-width: ${MAX_WRAPPER_SIZE};
        min-width: 280px;
        margin: 0 auto ${({ isStatus, extraMarginBot }) => isStatus ? 0 : extraMarginBot ? '50px' : '30px'};
        display: grid;
        align-items: flex-start;
        grid-template-areas: 'content'
                        'frame';
        grid-template-columns: 1fr;
        @media (min-width: 800px) {
            padding-left: 8px;
            padding-right: 8px;
            grid-template-columns: repeat(2, 1fr);
            grid-template-areas: 'frame content';
            margin: 0 auto;
        }
        @media (min-width: 1200px) {
            padding-bottom: ${({ isStatus }) => isStatus ? 0 : '90px'};
            grid-template-columns: calc(55% - 25px) calc(45% - 25px);
        }
        @media (min-width: 900px) and (min-height: 1500px) {
            height: calc(100% - 526px);
        }
    `,
    MainHeaderContainer: styled.header.attrs({ className: 'main-header' })`
        display: flex;
        max-width: ${MAX_WRAPPER_SIZE};
        min-height: 50px;
        min-width: 320px;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;

        margin-bottom: 17px;
        align-items: center;
        padding-left: 8px;
        padding-right: 8px;
        flex-wrap: wrap;
        box-sizing: border-box;
        @media (min-width: 600px) {
            justify-content: space-between;
        }
        @media (min-width: 700px) {
            margin-bottom: 43px;
            margin-top: 33px;
        }
    `,
    MainHeader: styled.h1.attrs({ className: 'main-h1' })`
        font-family: Toyota Display Bold,sans-serif;
        font-size: 23px;
        letter-spacing: -1.32px;
        color: #202020;
        margin: 0;
        width: 100%;
        text-align: center;
        order: 2;
        @media (min-width: 360px) {
            font-size: 25px;
        }
        @media (min-width: 600px) {
            width: initial;
            text-align: initial;
            order: 1;
        }
        @media (min-width: 700px) {
            font-size: 34px;
        }
    `,
    MainLogo: styled.a.attrs({ className: 'main-logo' })`
        height: 70px;
        order: 1;
        padding-top: 30px;
        @media (min-width: 600px) {
            order: 2;
            padding-top: 0;
            width: max-content;
            height: auto;
        }
    `,
    LogoImage: styled.img.attrs({ className: 'logo' })`
    `,
    CheckboxContainer: styled.div.attrs({ className: 'checkbox-container' })`
        padding-top: 10px;
        padding-bottom: 10px;
        position: relative;
    `,
    CheckboxWrapper: styled.div.attrs({ className: 'checkbox-wrapper' })`
        display: flex;
        flex-direction: column;
        margin: 0 8px;
        @media (max-width: 320px) {
            width: 94%;
        }
        @media (min-width: 700px) {
            margin: 0;
        }
    `,
    FrameLocker: styled.div.attrs({ className: 'frame-locker' })`
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(255,255,255,0.5);
        z-index: 200;
    `,
    FrameWrapper: styled.div.attrs({ className: 'frame-wrapper-div' })`
        width: 100%;
        margin: 0;
        height: 100%;
        grid-area: frame;
        position: relative;
        
        & iframe:not(.gpay-card-info-iframe) {
            position: relative;
            top: 0;
            left: 0;
            width: 100%;
            height: 595px;
        }
    `,

    ContentWrapper: styled.div.attrs({ className: 'contentWrapper' })`
        padding-bottom: ${({ isStatus }) => isStatus ? 0 : '56px'};
        grid-area: content;
        padding-left: 20px;
        background: #FFFFFF;
        border: 1px solid #F3F0F8;
        box-sizing: border-box;
        box-shadow: 0 5px 40px rgba(0, 0, 0, 0.1);
        min-width: 54vw;
        @media(min-width: 1220px){
            width: 100%;
            padding-left: 50px;
            padding-bottom:  56px;
            min-width: 48vw;
         };
        }
    `,
    PayButtonContainer: styled.div.attrs({ className: 'pay-buttons__container' })`
        display: flex;
        align-items: flex-start;
        padding-left: 8px;
        padding-right: 8px;
        justify-content: center;
        margin: 20px 0;
        @media(min-width: ${FRAME_MOBILE_SIZE.xl}){
            max-width: fit-content;
            margin-top: 0;
            .googlepay__container{
                margin-left: 10px;
            }
            
        }
        @media(min-width: ${FRAME_MOBILE_SIZE.xxl}){
            .googlepay__container{
                margin-left: 24px;
            }
        }
        @media(min-width: 721px) and (max-width: 799px){
            max-width: fit-content;
            .googlepay__container{
                margin-left: 10%;
            }
        }
        .apple{
            display: flex;
            align-items: center;
            justify-content: center;
            button{
                border-radius: 25px;
                height: 50px;
                width: 330px !important;
                @media(min-width: ${FRAME_MOBILE_SIZE.xl}){
                   margin-left: 2vw;
                   width: 272px !important;
                }
                @media(min-width: 721px) and (max-width: 799px){
                    margin-left: 4vw;
                    width: 260px !important;
                }
                @media(max-width: 720px){
                    margin-top: 20px;
                }
            }
        }
        @media(max-width: 800px){
            justify-content: center;
            align-items: center;
            .apple{
                margin-right: 0;
            }
            & > div{
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    `,
    StatusContainer: styled.div.attrs({ className: 'status__container' })`
        grid-area: frame;
        margin-top: 20px;

        @media(max-width: 800px){
            margin-top: 50px;
            padding-left: 8px;
            padding-right: 8px;
            margin-bottom: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            grid-row-gap: 20px;
        }
    `,
    StatusTextContainer: styled.div.attrs({ className: 'status__container' })`
        display: grid;
        grid-template-columns: 70px 1fr;
        grid-column-gap: 35px;

        @media(max-width: 800px){
            grid-template-columns: 1fr;
            justify-content: center;
            align-items: center;
            grid-row-gap: 20px;
            text-align: center;
            br{
                display: none;
            }
        }
    `,
    StatusText: styled.div.attrs({ className: 'status-text__container' })`
        font-family: Toyota Display, sans-serif;
        font-size: 30px;
        line-height: 110%;
        color: #282830;
    `,
    StatusSubText: styled.div.attrs({ className: 'status-subtext' })`
        margin-top: 17px;
        margin-bottom: 46px;
        font-family: Toyota Display, sans-serif;
        font-size: 16px;
        line-height: 237%;
        color: #282830;
    `,
    GooglePayContainer: styled.p.attrs({ className: 'googlepay__container' })`
        display: grid;
        width: 100%;
        grid-template-columns: 1fr;
        grid-row-gap: 8px;
        margin-bottom: 0;
        margin-top: 0;
        align-items: center;
        justify-content: center;
        & > div{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    `,
    GooglePayText: styled.p.attrs({ className: 'googlepay__text' })`
        font-family: 'Product Sans', sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 13px;
        text-align: center;
        color: #808080;
        max-width: 272px;
        margin: 0 auto;
        a{
            text-decoration: underline;
            color: #808080;
        }
    `,
};
